import React, { useMemo, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ResetPassword() {
    const navigate = useNavigate();
    const { resetPassword } = useAuth();
    const [searchParams] = useSearchParams();

    const token = useMemo(() => (searchParams.get('token') || '').trim(), [searchParams]);

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [infoMessage, setInfoMessage] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        setErrorMessage('');
        setInfoMessage('');

        if (!token) {
            setErrorMessage('Reset link is invalid or missing token.');
            return;
        }

        if (newPassword.length < 8) {
            setErrorMessage('Password must be at least 8 characters long.');
            return;
        }

        if (newPassword !== confirmPassword) {
            setErrorMessage('Password and confirm password do not match.');
            return;
        }

        setIsSubmitting(true);
        const result = await resetPassword({ token, newPassword });
        setIsSubmitting(false);

        if (!result.success) {
            setErrorMessage(result.message || 'Unable to reset password.');
            return;
        }

        setInfoMessage(result?.data?.message || 'Password reset successful. Redirecting to login...');
        window.setTimeout(() => {
            navigate('/login', {
                replace: true,
                state: {
                    message: 'Password reset successful. Please login with your new password.',
                },
            });
        }, 1200);
    };

    return (
        <div className="page-content pt-20 pb-20">
            <div className="container">
                <div className="row">
                    <div className="col-xl-8 col-lg-10 col-md-12 m-auto">
                        <div className="row">
                            <div className="col-lg-6 pr-30 d-none d-lg-block">
                                <img className="border-radius-15" src="assets/imgs/page/reset_password.svg" alt="" />
                            </div>
                            <div className="col-lg-6 col-md-8">
                                <div className="login_wrap widget-taber-content background-white">
                                    <div className="padding_eight_all bg-white">
                                        <div className="heading_s1">
                                            <h1 className="mb-5">Set New Password</h1>
                                            <p className="mb-30">Create a secure password and confirm it. <Link to="/login">Back to Login</Link></p>
                                        </div>
                                        {infoMessage ? <div className="alert alert-info py-2">{infoMessage}</div> : null}
                                        {errorMessage ? <div className="alert alert-danger py-2">{errorMessage}</div> : null}

                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group">
                                                <input
                                                    type="password"
                                                    required
                                                    name="newPassword"
                                                    value={newPassword}
                                                    onChange={(event) => setNewPassword(event.target.value)}
                                                    placeholder="New password"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="password"
                                                    required
                                                    name="confirmPassword"
                                                    value={confirmPassword}
                                                    onChange={(event) => setConfirmPassword(event.target.value)}
                                                    placeholder="Confirm password"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <button
                                                    type="submit"
                                                    className="btn btn-heading btn-block hover-up"
                                                    disabled={isSubmitting}
                                                >
                                                    {isSubmitting ? 'Resetting...' : 'Reset Password'}
                                                </button>
                                            </div>
                                        </form>
                                        <p className="mb-0">Didn&apos;t get email? <Link to="/password-reset">Send link again</Link></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResetPassword;
